import { inject, injectable } from 'tsyringe'
import { ApiService } from '../api/ApiService'
import type { ModelResponse } from '../shared/types/Model'

@injectable()
export class ModelService {
  constructor(@inject(ApiService) private readonly api: ApiService) {}

  async getModels(language?: string | null): Promise<ModelResponse[]> {
    try {
      const { models } = await this.api.getModels(language)
      return models
    } catch (error) {
      console.error('Failed to fetch models:', error)
      throw new Error('Failed to load model data. Please try again later.')
    }
  }
}
